import axios from "axios";
import { MembershipI, MembershipUnit } from "types/MembershipsI";
import { ResponseError } from "types/responses/ResponseError";
import { MembershipResponse } from "types/responses/MembershipResponse";
import { getHeaders } from "../AuthHeader";

const API_URL = process.env.REACT_APP_API_URL;


const getMemberhipUnit = (unit: string) => {
    switch(unit) {
        case ('Cas/hodina'): {
            return MembershipUnit.time_hour
        }
        case ('Cas/minuta'): {
            return MembershipUnit.time_minute
        }
        case ('Mnozstvi'): {
            return MembershipUnit.amount
        }
        case ('vstup'): {
            return MembershipUnit.entrie
        }
        case ('Kc'): {
            return MembershipUnit.price
        }
        default: {
            return null
        }
    }
}


async function getUserMemberships(client_id: any) {

    // console.log(process.env);
    
    try {
        // console.log("Get User Memberships");
        
        const response = await axios.get(
            API_URL + '/user/memberships',
            {
                params: {
                    client_id: client_id
                },
                headers: getHeaders() 
            });
        // console.log("getUserMemberships RESPONSE");
        // console.log(response);
        
        if (!('memberships' in response.data)) {
            throw Error
        }
        

        const json_memberships:MembershipResponse[] = JSON.parse(response.data.memberships)
        
        // console.log(json_memberships);
        

        let memberships:MembershipI[] = []

        json_memberships.forEach((value, index) => {
            let m:MembershipI = {
                name: value.NAZEV,
                entries: value.ZDARMA,
                remaining_entries: value.ZBYVA,
                unit: getMemberhipUnit(value.JEDNOTKA),
                valid_from: (value.OD_KDY) ? new Date(value.OD_KDY) : null,
                valid_to: (value.DO_KDY) ? new Date(value.DO_KDY) : null,
                membership_id: value.ID_SLEVY,
                sports_ground_id: value.ID_TYP_SPORTOVISTE,
                price_discount: value.SLEVA_PRC
            } 
            memberships.push(m)
        })

        return memberships

    } catch(error) {
        // console.log(error);
        
        return ResponseError.general_error
    }
    
}

export default getUserMemberships